import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { PAGE_TYPES } from 'constants';
import { routes } from 'router';

export const useCurrentRoute = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const purchaseRoute = useMemo(() => location.pathname.includes('achat-'), [location.pathname]);

  const isTravelRoute = useMemo(() => {
    return (location.pathname.includes('voyages') && !purchaseRoute) || searchParams.get('type') === PAGE_TYPES.travels;
  }, [location.pathname, searchParams.get('type')]);

  const isLeisureRoute = useMemo(() => {
    return (
      (location.pathname.includes('loisirs') && !purchaseRoute) || searchParams.get('type') === PAGE_TYPES.leisures
    );
  }, [location.pathname, searchParams.get('type')]);

  const isSportRoute = useMemo(() => {
    return (location.pathname.includes('sport') && !purchaseRoute) || searchParams.get('type') === PAGE_TYPES.sport;
  }, [location.pathname, searchParams.get('type')]);

  const isGiftcardRoute = useMemo(() => {
    return (
      (location.pathname.includes('cartes-cadeaux') && !purchaseRoute) ||
      searchParams.get('type') === PAGE_TYPES.giftcards
    );
  }, [location.pathname, searchParams.get('type')]);

  const pageType = useMemo(() => {
    if (isTravelRoute || location.pathname === routes.home.path) {
      return PAGE_TYPES.travels;
    } else if (isLeisureRoute) {
      return PAGE_TYPES.leisures;
    } else if (isSportRoute) {
      return PAGE_TYPES.sport;
    } else if (isGiftcardRoute) {
      return PAGE_TYPES.giftcards;
    }

    return null;
  }, [isTravelRoute, isLeisureRoute, isSportRoute, isGiftcardRoute, location.pathname]);

  return { isTravelRoute, isLeisureRoute, isSportRoute, isGiftcardRoute, pageType };
};
